<template>
  <div>
    <a-modal
      :title="classInfo ? classInfo.className : '学生详情'"
      :maskClosable="false"
      :width="1250"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :cancelText="'取消'"
      :okText="'确定'"
      @cancel="handleCancel"
      :footer="null"
    >
      <div class="tab-list">
        <div
          class="tab hover-font-active"
          :class="{ 'tab-active': tabIndex == '1' }"
          @click="tabChange('1')"
        >
          报班名单
        </div>
        <div
          class="tab hover-font-active"
          :class="{ 'tab-active': tabIndex == '2' }"
          @click="tabChange('2')"
        >
          退班名单
        </div>
      </div>
      <div class="class-list">
        <a-form layout="inline">
          <a-form-item class="name" label="ID"
            ><a-input
              class="form-cell"
              type="text"
              placeholder="请输入"
              v-model="queryParam.studentId"
            ></a-input
          ></a-form-item>
          <a-form-item class="name" label="姓名"
            ><a-input
              class="form-cell"
              type="text"
              placeholder="请输入"
              v-model="queryParam.studentName"
            ></a-input
          ></a-form-item>
          <a-form-item class="name" label="学号"
            ><a-input
              class="form-cell"
              type="text"
              placeholder="请输入"
              v-model="queryParam.studentNumber"
            ></a-input
          ></a-form-item>
          <a-form-item label="年级">
            <a-select
              class="form-cell"
              placeholder="请选择"
              v-model="queryParam.gradeId"
            >
              <a-select-option
                v-for="(item, index) in $store.getters.getGradeScope"
                :key="index"
                :value="item.id"
                >{{ item.tagName }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <c-original-class
            :classCode.sync="queryParam.originalClassId"
          ></c-original-class>
          <a-form-item class="search-oper">
            <a-button type="primary" @click="headleChange()">查询</a-button>
            <a-button type="primary" @click="() => (queryParam = {})"
              >重置</a-button
            >
          </a-form-item>
        </a-form>
        <div class="oper">
          <a-button
            class="transfer-class"
            type="primary"
            @click="transferClass()"
            v-if="
              roleId == '3' &&
              tabIndex == '1' &&
              classInfo &&
              classInfo.status == '0'
            "
          >
            转班
          </a-button>
          <a-button
            class="shift-class"
            type="primary"
            @click="$refs.insertClass.init(classInfo.id)"
            v-if="
              tabIndex == '1' &&
              classInfo &&
              (classInfo.status == '0' || classInfo.status == '1') &&
              roleId == '3'
            "
          >
            插班
          </a-button>
          <a-button class="export" type="primary" @click="exportStudent"
            >导出</a-button
          >
          <a-button
            v-if="
              classInfo &&
              ((roleId == '3' &&
                tabIndex == '1' &&
                classInfo.offeringType == '1') ||
                (roleId != '3' &&
                  tabIndex == '1' &&
                  classInfo.offeringType == '2'))
            "
            class="export"
            type="primary"
            @click="deleteClass"
            >退班</a-button
          >
        </div>
        <!-- 表格数据 -->
        <template v-if="roleId == '3' && tabIndex == '1'">
          <a-table
            :columns="columns"
            :dataSource="studentList"
            rowKey="id"
            :pagination="false"
            :show-total="showTotal"
            v-if="visible && refreshTable"
            :row-selection="rowSelection"
          >
            <template slot="ID" slot-scope="text, record">
              <a-popover placement="bottom">
                <template #title>进班记录ID：{{ record.tcsId }}</template>
                <template #content>
                  <p>学生ID：{{ record.id }}</p>
                  <p>学生姓名：{{ record.studentName }}</p>
                  <p>学号：{{ record.studentNumber }}</p>
                  <p>生日：{{ record.birthday }}</p>
                  <p>年级：{{ record.grade }}</p>
                  <p>班级名称：{{ record.className }}</p>
                  <p>班级ID：{{ record.classId }}</p>
                  <p>进班时间：{{ record.applyDate }}</p>
                </template>
                {{ record.id }}
              </a-popover>
            </template>
            <template slot="mobile" slot-scope="text, record">
              <a-popover placement="rightTop" v-if="record.mobile">
                <template #content>
                  <p v-for="(item,index) in record.mobile" :key="index">
                    <!-- {{ item.indexOf('DU:') != -1 ? '钉钉用户' : item }} -->
                      <showMobile :id="item.id" :nickName="item.nickName" :mobile="item.mobile"></showMobile>
                  </p>
                </template>
                <span><a-icon style="margin-left: 3px" type="search" /></span>
              </a-popover>
            </template>
            <template slot="remark" slot-scope="text, record">
              <a-popover
                v-if="record.remark.length && !record.editable"
                placement="topLeft"
              >
                <template #content>
                  {{ record.remark }}
                </template>
                <span class="ellipsis" @click="edit(record)">{{ text }}</span>
              </a-popover>
              <template v-if="!record.remark.length && !record.editable">
                <div @click="edit(record)">无</div>
              </template>
              <a-input
                v-if="record.editable"
                style="margin: -5px 0"
                placeholder="请输入最多50字备注"
                v-model="record.remark"
                :maxLength="50"
                autoFocus
                @blur="blur($event, record)"
              />
            </template>
            <!-- <span
              slot="action"
              slot-scope="text, record"
              v-if="tabIndex == '1'"
            > -->
              <!-- 删除 -->
              <!-- <template v-if="!record.orderStatusText"> -->
              <!-- 学校操作退班 -->
              <!-- <template v-if="classInfo.offeringType == '1'">
                <a @click="deleteClass(record)">退班</a>
              </template> -->
              <!-- 课程方操作退班 -->
            <!-- </span> -->
          </a-table>
          <div class="show-total"> 总共<span>{{ pagination.total }}</span>条</div>
        </template>
        <template v-else>
          <a-table
            :columns="columns"
            rowKey="id"
            :dataSource="studentList"
            :pagination="false"
            v-if="visible && refreshTable"
            :row-selection="rowSelection"
          >
          <template slot="ID" slot-scope="text, record">
            <a-popover placement="bottom">
              <template #title>进班记录ID：{{ record.tcsId }}</template>
              <template #content>
                <p>学生ID：{{ record.id }}</p>
                <p>学生姓名：{{ record.studentName }}</p>
                <p>学号：{{ record.studentNumber }}</p>
                <p>生日：{{ record.birthday }}</p>
                <p>年级：{{ record.grade }}</p>
                <p>班级ID：{{ record.classId }}</p>
                <p>班级名称：{{ record.className }}</p>
                <p>进班时间：{{ record.applyDate }}</p>
                <p>退班时间：{{ record.quitDate }}</p>
              </template>
              {{ record.id }}
            </a-popover>
          </template>
          <template slot="mobile" slot-scope="text, record">
              <a-popover placement="rightTop" v-if="record.mobile">
                <template #content>
                  <p v-for="(item,index) in record.mobile" :key="index">
                    <showMobile :id="item.id" :nickName="item.nickName" :mobile="item.mobile"></showMobile>
                  </p>
                </template>
                <span><a-icon style="margin-left: 3px" type="search" /></span>
              </a-popover>
            </template>
            <!-- <span
              slot="action"
              slot-scope="text, record"
              v-if="tabIndex == '1'"
            > -->
              <!-- 删除 -->
              <!-- <template v-if="!record.orderStatusText"> -->
              <!-- <template v-if="classInfo.offeringType == '2'">
                <a @click="deleteClass(record)">退班</a>
              </template> -->
            <!-- </span> -->
            <template slot="remark" slot-scope="text, record">
              <a-popover
                v-if="record.remark.length && !record.editable"
                placement="topLeft"
              >
                <template #content>
                  {{ record.remark }}
                </template>
                <span class="ellipsis" @click="edit(record)">{{ text }}</span>
              </a-popover>
              <template v-if="!record.remark.length && !record.editable">
                <div @click="edit(record)">无</div>
              </template>
              <a-input
                v-if="record.editable"
                style="margin: -5px 0"
                placeholder="请输入最多50字备注"
                v-model="record.remark"
                :maxLength="50"
                autoFocus
                @blur="blur($event, record)"
              />
            </template>
          </a-table>
          <div class="show-total"> 总共<span>{{ studentList.length }}</span>条</div>
        </template>
      </div>
    </a-modal>
    <insert-class ref="insertClass" @refreshList="refreshList"></insert-class>
    <transfer-class
      ref="transferClass"
      @refreshList="refreshList"
    ></transfer-class>
    <a-modal
      :title="`已选择${selectedStudent.length}名学生退出班级`"
      :visible="deleteClassModal"
      :confirm-loading="confirmLoading"
      @ok="deleteClassOk"
      @cancel="delectClassCancel"
    >
      <div class="selectClass">
        <div>退班备注</div>
        <a-input
          type="text"
          placeholder="请输入最多50字备注"
          :maxLength="50"
          v-model="selectClassRemark"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
import classSet from '../../api/classSet'

import InsertClass from './components/InsertClass'

import TransferClass from './components/TransferClass'

import COriginalClass from '@/components/COriginalClass'

import showMobile from '../../components/showMobile/showMobile'
import { del } from 'vue'
const columns = [
  {
    title: '学生ID',
    dataIndex: 'id',
    width: 60,
    scopedSlots: { customRender: 'ID' },
  },
  {
    title: '姓名',
    dataIndex: 'studentName',
  },
  {
    title: '性别',
    dataIndex: 'genderText',
    width: 60,
  },
  {
    title: '学号',
    dataIndex: 'studentNumber',
  },
  {
    title: '原始班级',
    dataIndex: 'originalClassName',
  },
  // {
  //   title: '身份证',
  //   dataIndex: 'idCard',
  // },
  {
    title: '家长手机号',
    dataIndex: 'mobile',
    scopedSlots: { customRender: 'mobile' },
  },
  {
    title: '备注',
    dataIndex: 'remark',
    scopedSlots: { customRender: 'remark' },
    width: 160,
  },
  //   {
  //     title: '操作',
  //     dataIndex: 'action',
  //     scopedSlots: { customRender: 'action' },
  //   },
]
export default {
  name: 'classFormModal',
  data() {
    return {
      columns: JSON.parse(JSON.stringify(columns)),
      visible: false,
      confirmLoading: false,
      studentList: [], //学生列表
      classInfo: null, //学生信息
      tabIndex: '1',
      selectedStudent: [], //选择的学生
      selectedRowKeys: [],
      roleId: '',
      refreshTable: true,
      queryParam: {}, //查询参数
      offeringType: '', // 判断是学校还是课程方账号
      editingKey: '',
      deleteClassModal: false, // 退班确认弹窗
      selectClassRemark: '',
      pagination: {
        // disabled:true,
        pageSize: '',
        total: 0,
        // showSizeChanger:false,
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
        // showSizeChanger: true,
        pageSizeOptions: '',
        // current: 1,
        // currentPage: 1,
      }, //分页数据对象
    }
  },
  components: {
    InsertClass,
    TransferClass,
    COriginalClass,
    showMobile
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this
      return {
        selectedRowKeys, // 一定要加上这一行代码，清除才会有作用
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(selectedRowKeys, selectedRows)
          this.selectedRowKeys = selectedRowKeys
          this.selectedStudent = selectedRows
        },
      }
    },
  },
  methods: {
    //初始化，显示
    init(detail) {
      this.pagination.total = undefined
      this.visible = true
      this.classInfo = detail
      this.tabChange('1')
      this.selectedStudent = []
      console.log('判断条件信息:', this.classInfo.offeringType, this.roleId)
    },
    showTotal(total) {
      return `Total ${pagination.total} items`;
    },
    headleChange() {
      // if (
      //   this.queryParam.studentId &&
      //   !/^[0-9]*$/.test(this.queryParam.studentId)
      // ) {
      //   this.$message.error('ID仅限输入数字')
      //   return
      // }
      this.tabChange()
    },

    

    //插班学生删除
    deleteClass(val) {
      if (this.selectedStudent.length) this.deleteClassModal = true
      else this.$message.error('请选择要退班的学生')
    },

    deleteClassOk() {
      console.log(this.selectedStudent)
      const studentIds = this.selectedStudent.map((i) => i.id)
      const req = {
        classId: this.classInfo.id,
        studentIds: studentIds,
        remark: this.selectClassRemark,
      }
      classSet.quitClass(req).then((res) => {
        this.selectedRowKeys = []
        this.selectedStudent = []
        this.$message.success('退班成功')
        this.$forceUpdate()
        this.listApplyStudent()
        this.delectClassCancel()
        //前端模拟删除
        // self.deleteClassData(self.studentList, val.id)
      })
    },

    delectClassCancel() {
      this.deleteClassModal = false
      this.selectClassRemark = ''
    },

    //前端模拟删除
    deleteClassData(data, id) {
      for (let i in data) {
        if (data[i].id == id) {
          data.splice(i, 1)
          break
        }
      }
    },

    //转班
    transferClass() {
      const req = {
        id: this.classInfo.id,
        className: this.classInfo.className,
        selectedStudent: this.selectedStudent,
      }
      this.$refs.transferClass.init(req)
    },

    //table选中事件
    onSelectChange(selectedRowKeys, value) {
      this.selectedStudent = value
    },

    refreshList(dataList) {
      this.refreshTable = false
      this.tabChange(this.tabIndex)
    },

    tabChange(value) {
      if (value) {
        this.tabIndex = value
        this.queryParam = {}
      }
      this.columns = JSON.parse(JSON.stringify(columns))
      //报班
      if (this.tabIndex == '1') {
        const ls = [
          {
            title: '进班原因',
            dataIndex: 'applyTypeText',
            width: 80,
          },
          {
            title: '进班时间',
            dataIndex: 'applyDate',
            width: 160,
          },
          {
            title: '订单号',
            dataIndex: 'orderNo',
          },
          {
            title: '订单状态',
            dataIndex: 'orderStatusText',
            width: 80,
          },
        ]
        this.columns.splice(5, 0, ...ls)
        this.listApplyStudent()
      }
      //退班
      else {
        const ls = [
          {
            title: '退班原因',
            dataIndex: 'quitTypeText',
            width: 80,
          },
          {
            title: '退班时间',
            dataIndex: 'quitDate',
            width: 160,
          },
          {
            title: '退款单号',
            dataIndex: 'refundNo',
          },
          {
            title: '退款单状态',
            dataIndex: 'refundStatusText',
            width: 80,
          },
        ]
        this.columns.splice(5, 0, ...ls)
        this.listDropStudent()
      }
    },

    //获取报班名单
    listApplyStudent() {
      classSet
        .listApplyStudent(this.classInfo.id, this.queryParam)
        .then((res) => {
          this.studentList = res.data.map((item) => {
            if (item.mobile) {
              item.mobile = item.mobile.split(',').map(i => {
                return {
                  id: item.id,
                  nickName: i.split('\t')[0],
                  mobile: i.split('\t')[1],
                }
              })
            }
            item.remark = item.remark ? item.remark : ''
            item.editable = false;
            item.focus = false;
            return item
          })
          this.pagination.total = res.data.length
          console.log(res.data,this.pagination.total,'列表的内容是什么')
          this.refreshTable = true
        })
    },

    //退班名单
    listDropStudent() {
      classSet
        .listDropStudent(this.classInfo.id, this.queryParam)
        .then((res) => {
          this.studentList = res.data.map((item) => {
            if (item.mobile) {
              item.mobile = item.mobile.split(',').map(i => {
                return {
                  id: item.id,
                  nickName: i.split('\t')[0],
                  mobile: i.split('\t')[1],
                }
              })
            }
            item.remark = item.remark ? item.remark : ''
            item.editable = false;
            item.focus = false;
            return item
          })
          this.refreshTable = true
        })
    },

    //隐藏
    handleCancel() {
      this.visible = false
      this.$emit('closeForm')
      this.queryParam = {}
      this.selectedRowKeys = []
    },

    //导出
    exportStudent() {
      let _this = this
      this.$confirm({
        title: '注意',
        okText: '确定',
        cancelText: '取消',
        icon:'exclamation-circle',
        content: '注意：仅支持导出1万条数据记录，如需导出更多数据请提出人工导出申请',
        onOk() {
          _this.$message.success('导出中...')
      const _tempFun =
      _this.tabIndex == '1'
          ? classSet.excelApplyStudent
          : classSet.excelDropStudent

      _tempFun(_this.classInfo.id, _this.queryParam).then((res) => {
        const url = window.URL.createObjectURL(res.data) //URL.createObjectURL(object)表示生成一个File对象或Blob对象
        let dom = document.createElement('a') //设置一个隐藏的a标签，href为输出流，设置download
        dom.style.display = 'none'
        dom.href = url
        dom.setAttribute('download', '学生列表.xlsx')
        document.body.appendChild(dom)
        dom.click()
      })
        },
      })
    },
    // 更新编辑的备注
    editStudent(student) {
      const cur = this.studentList.findIndex((i) => i.tcsId == student.tcsId)
      if (cur != -1) Object.assign(this.studentList[cur], student)
    },
    // 编辑备注 显示input
    edit(record) {
      console.log("edit:"+record.tcsId+",this.studentList"+this.studentList.length)
      const target = this.studentList.findIndex(
        (item) => {
          console.log("item:"+record.tcsId+",item.tcsId:"+item.tcsId);
          return record.tcsId === item.tcsId
        }
      )
      console.log("target:"+target)
      if (target != -1) {
        record.editable = true
        record.focus = true
        record.originRemark = record.remark
        this.studentList[target].editable = true
        this.studentList[target].focus = true
        this.$forceUpdate()
      }
    },
    // 备注input失去焦点
    blur(e, record) {
      console.log(e)
      const target = this.studentList.findIndex(
        (item) => record.tcsId === item.tcsId
      )
      if (target != -1) {
        this.studentList[target].editable = false
        this.studentList[target].focus = false
        this.studentList[target].remark = record.remark.trim()
        this.$forceUpdate()
        if (record.originRemark === record.remark) {
          delete record.originRemark
          return
        }
        const req = { remark: record.remark, tcsId: record.tcsId }
        classSet.updateRemark(req).then((res) => {
          // this.$message.success('修改成功');
        }).finally(() => {
          delete record.originRemark
        })
      }
    },
  },
  created() {
    this.pagination.total = undefined
    this.$store.dispatch('getUserInfo').then((res) => {
      console.log('roleId', res)
      this.roleId = res.accRole.id
    })
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.class-list {
  height: calc(100vh - 320px);
  overflow-y: auto;
  overflow-x: hidden;
  .oper {
    text-align: right;
    margin-bottom: 10px;
    margin-top: 14px;
    margin-left: 4px;
    > .export {
      float: left;
      margin-left: 10px;
      margin-bottom: 10px;
      z-index: 999;
    }
  }
}
.class-cell {
  font-size: 14px;
  color: $normal-color-dark;
  line-height: 26px;
}
.tab-active {
  color: $primary-color;
}
.tab-list {
  border-bottom: 1px solid $border-color;
  padding: 0px 0px 10px;
  margin-bottom: 20px;
  > .tab {
    display: inline-block;
    margin-right: 30px;
    font-size: 16px;
  }
}
.transfer-class {
  float: left;
  margin-bottom: 10px;
  z-index: 999;
}
.shift-class {
  float: left;
  margin-left: 10px;
  margin-bottom: 10px;
  z-index: 999;
}
.search-oper {
  button {
    margin: 0px 5px;
  }
}
/deep/.ant-modal-title {
  font-weight: bold;
}
.ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  overflow: hidden;
}
.selectClass {
  display: flex;
  align-items: center;
  div {
    width: 100px;
  }
}

.show-total{
  margin: 30px 25px 30px 0;
  text-align: right;
  font-size: 15px;
  span{
    margin: 0 4px;
  }
}
</style>
